import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import ButtonGroup from "../../components/ButtonGroup";
import ErrorMessage from "../../components/ErrorMessage";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import Main from "../../components/Main";
import SideMenu from "../../components/SideMenu";
import SimpleButton from "../../components/SimpleButton";
import Spacer from "../../components/Spacer";
import SubPage from "../../components/SubPage";
import SubPagesContainer from "../../components/SubPagesContainer";
import SweepItem from "../../components/SweepItem";
import history from "../../providers/history";
import { IApplicationState } from "../../store";
import { profileUserRequest } from "../../store/authentication/slice";
import { startEditingSweep, sweepsListRequest } from "../../store/sweeps/slice";
import GuestForm from "../GuestForm";
import ItemDetails from "../ItemDetails";
import ItemForm from "../ItemForm";
import RoomDetails from "../RoomDetails";
import RoomForm from "../RoomForm";
import SweepDetails from "../SweepDetails";
import SweepForm from "../SweepForm";
import { Container, Content, CustomLink, SweepsList } from "./styles";
import GuestMember from "../GuestMember";
import SweepWorkRegisterForm from "../SweepWorkRegisterForm";
import RoomWorkRegisterForm from "../RoomWorkRegisterForm";

const Dashboard: React.FC = () => {
    const sweeps = useSelector((state: IApplicationState) => state.sweeps)

    const { t } = useTranslation();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(sweepsListRequest({
            limit: 24,
            page: 1,
            isArchived: true
        }))
        dispatch(sweepsListRequest({}))

        dispatch(profileUserRequest())
    }, [dispatch]);


    const paginationSweeps = () => {
        const elements: any[] = [];

        for (let i = 1; i <= sweeps.pagination.totalPages; i++) {
            elements.push(
                <SimpleButton
                    key={`sweep-pagination-button-${i}`}
                    size="small"
                    onClick={() => dispatch(sweepsListRequest({
                        page: i,
                        limit: 24,
                        isArchived: true
                    }))}
                    color={i === sweeps.pagination.currentPage ? "primary" : "secondary"}
                >
                    {i}
                </SimpleButton>
            );
        }

        return elements;
    }

    console.log('PAGINATION', paginationSweeps());
    console.log('PAGE', sweeps.pagination);


    return <Container id="container">
        <Header />

        <Content>
            <SideMenu />
            <Main>
                <h1>{t("pages.sweeps.sweeps_list")}</h1>

                <Spacer size={20} />

                <ButtonGroup>
                    <SimpleButton color="primary" prependIcon="plus" onClick={() => {
                        dispatch(startEditingSweep({
                            name: "",
                            members: [],
                            rooms: [],
                            times: []
                        }))

                        history.push("sweep/form")
                    }}>{t("pages.sweeps.buttons.add_sweep")}</SimpleButton>
                </ButtonGroup>

                <Spacer size={20} />

                {sweeps.isLoading && <>
                    <p>{t("common.loading")}...</p>
                </>}

                {!sweeps.isLoading && !sweeps.error && sweeps.data.filter(sweep => !sweep.archivedAt).length === 0 && <>
                    <ErrorMessage>
                        {t("pages.sweeps.zero_sweeps")}
                    </ErrorMessage>
                </>}

                {!sweeps.isLoading && sweeps.error && <>
                    <ErrorMessage>
                        {sweeps.error.message}
                    </ErrorMessage>
                </>}

                {!sweeps.isLoading && !sweeps.error && sweeps.data.filter(sweep => !sweep.archivedAt).length > 0 && <SweepsList>
                    {sweeps.data.filter(sweep => !sweep.archivedAt).map(sweep => sweep.archivedAt === null && <CustomLink key={sweep.id} to={`/sweep/${sweep.id}`}><SweepItem sweep={sweep} /></CustomLink>)}
                </SweepsList>}

                <Spacer size={20} />

                {sweeps.data.filter(sweep => sweep.archivedAt).length > 0 && <h1>{t("pages.sweeps.sweeps_archived_list")}</h1>}

                <Spacer size={20} />

                {!sweeps.isLoading && !sweeps.error && sweeps.data.filter(sweep => sweep.archivedAt).length > 0 && <SweepsList>
                    {sweeps.data.filter(sweep => sweep.archivedAt).map(sweep => sweep.archivedAt !== null && <CustomLink key={sweep.id} to={`/sweep/${sweep.id}`}><SweepItem sweep={sweep} /></CustomLink>)}
                </SweepsList>
                }

                <Spacer size={20} />


                <ButtonGroup>
                    {sweeps.pagination.totalPages > 1 && paginationSweeps()}
                </ButtonGroup>

                <Spacer size={20} />

            </Main>
        </Content>

        <Routes>
            <Route path={'/sweep/:id'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <SweepDetails />
                    </SubPage>
                </SubPagesContainer>
            )} />
            <Route path={'/sweepArchived/:id'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <SweepDetails />
                    </SubPage>
                </SubPagesContainer>
            )} />
            <Route path={'/sweep/:idSweep/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <SweepForm />
                    </SubPage>
                </SubPagesContainer>
            )} />
            <Route path={'/sweep/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <SweepForm />
                    </SubPage>
                </SubPagesContainer>
            )} />
            <Route path={'/room/:idSweep/:idRoom'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <RoomDetails />
                    </SubPage>
                </SubPagesContainer>
            )} />

            <Route path={'/room/:idSweep/:idRoom/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <RoomForm />
                    </SubPage>
                </SubPagesContainer>
            )} />

            <Route path={'/room/:idSweep/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <RoomForm />
                    </SubPage>
                </SubPagesContainer>
            )} />

            <Route path={'/guest-member/:idSweep/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <GuestForm />
                    </SubPage>
                </SubPagesContainer>
            )} />

            <Route path={'/guest-member/:idSweep/:idMember/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <GuestForm />
                    </SubPage>
                </SubPagesContainer>
            )} />

            <Route path={'/add-member/:idSweep/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <GuestMember />
                    </SubPage>
                </SubPagesContainer>
            )} />
            <Route path={'/sweep-work-register/:idSweep/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <SweepWorkRegisterForm />
                    </SubPage>
                </SubPagesContainer>
            )} />
            <Route path={'/room-work-register/:isSweep/:idRoom/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <RoomWorkRegisterForm />
                    </SubPage>
                </SubPagesContainer>
            )} />
            <Route path={'/item/:idSweep/:idRoom/:idItem'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <ItemDetails />
                    </SubPage>
                </SubPagesContainer>
            )} />

            <Route path={'/item/:idSweep/:idRoom/:idItem/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <ItemForm />
                    </SubPage>
                </SubPagesContainer>
            )} />

            <Route path={'/item/:idSweep/:idRoom/form'} element={(
                <SubPagesContainer>
                    <SubPage>
                        <ItemForm />
                    </SubPage>
                </SubPagesContainer>
            )} />
        </Routes>
        <Footer />
    </Container>
}

export default Dashboard;